import API from '@/api/api.js'

export default class MyAPIList {
  constructor() {
    let api = new API();
    this.api = api;
  }


  getRenewalList(params, success, error) {
    this.api.get('/renewal', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }

  renewLifePolicy(params, success, error) {
    this.api.post('/renewal/renewLifePolicy', params, (json) => {
      success(json);
    }, (err) => {
      error(err);
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/Quick/apiList.js